import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesListComponent } from './components/messages-list/messages-list.component';
import { MessagesHomeComponent } from './components/messages-home/messages-home.component';
import { MessagesRouting } from './messages.routing';
import { environment } from '../../environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ComposeMessageComponent } from './components/compose-message/compose-message.component';
import { SendMessageActionComponent } from './components/send-message-action/send-message-action.component';
import { SharedModule, ErrorModule } from '@universis/common';
import { MostModule } from '@themost/angular';
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    InfiniteScrollModule,
    NgxDropzoneModule,
    SharedModule,
    ErrorModule,
    MostModule,
    RouterModule
  ],
  providers: [
  ],
  declarations: [
    ComposeMessageComponent,
    SendMessageActionComponent
  ],
  exports: [
    ComposeMessageComponent,
    SendMessageActionComponent
  ],
  entryComponents: [
    SendMessageActionComponent
  ]
})
export class MessagesSharedModule {
  constructor(private _translateService: TranslateService) {
    environment.languages.forEach((culture) => {
      import(`./i18n/messages.${culture}.json`).then((translations) => {
        this._translateService.setTranslation(culture, translations, true);
      });
    });
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MessagesSharedModule,
      providers: [

      ]
    };
  }

}
